import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { CartService } from '../../services/cart.service';
import { WishlistService } from '../../services/wishlist.service';
import { AuthModalService } from '../auth-modal/auth-modal.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, FormsModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  private authService = inject(AuthService);
  private cartService = inject(CartService);
  private router = inject(Router);
  protected wishlistService = inject(WishlistService);
  private authModalService = inject(AuthModalService);
  wishlist = this.wishlistService.getWishlistSignal();

  searchQuery = '';
  isSearchOpen = false;

  userProfile$ = this.authService.userProfile$;
  cartItemCount$ = this.cartService.getCartItemCount();
  isMobileMenuOpen = false;

  ngOnInit() {
    this.userProfile$.subscribe(user => {
      if (user?.uid) {
        this.wishlistService.loadWishlist(user.uid);
      }
    });
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  async logout() {
    this.closeMobileMenu();
    await this.authService.logout();
  }

  getInitials(name: string | null): string {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
    if (!this.isSearchOpen) {
      this.searchQuery = '';
    }
  }

  onSearch() {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/home'], { 
        queryParams: { q: this.searchQuery.trim() },
        queryParamsHandling: 'merge'
      });
      this.isSearchOpen = false;
      this.searchQuery = '';
      this.closeMobileMenu();
    }
  }

  openSignInModal() {
    this.closeMobileMenu();
    this.authModalService.openSignIn();
  }

  openSignUpModal() {
    this.closeMobileMenu();
    this.authModalService.openSignUp();
  }
}
